<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />


		<!-- * 内页banner * -->
		<div class="page-banner">
			<img src="@/assets/images/banner09.png">
			<div class="nybt">
				<h3>人才招聘</h3>
			</div>
		</div>

		<!-- * 当前位置 * -->
		<div class="page-position">
			<div class="wh">
				当前位置：
				<a href="/">首页</a>
				&gt;
				人才招聘
			</div>
		</div>
		<div class="page-wrap">
			<div class="wh clearfix">


				<!-- * 右侧 * -->
				<div class="page-wrap-right">

					<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
						<ul class="xypg-left-nav">
						</ul>
					</div>

					<div class="xypg-right-content">
						<form class="form-horizontal" id="message-form" onsubmit="return false">
							<div class="form-group">
								<label for="name" class="col-sm-2 control-label"><span class="red-star">*</span> <span
										class="wz">姓名</span>：</label>
								<div class="col-sm-7">
									<input id="name" name="name" type="text" class="form-control" placeholder="请输入您的姓名"
										v-model="form.empName" />
								</div>
								<div class="pull-left">
									<div class="error-info"></div>
								</div>
							</div>
							<div class="form-group">
								<label for="name" class="col-sm-2 control-label"><span class="red-star">*</span> <span
										class="wz">年龄</span>：</label>
								<div class="col-sm-7">
									<input id="name" name="name" type="text" class="form-control" placeholder="请输入您的年龄"
										v-model="form.empAge" />
								</div>
								<div class="pull-left">
									<div class="error-info"></div>
								</div>
							</div>
							<div class="form-group">
								<label for="contact" class="col-sm-2 control-label"><span class="red-star">*</span>
									<span class="wz">电话</span>：</label>
								<div class="col-sm-7">
									<input id="contact" name="contact" type="text" class="form-control"
										placeholder="请输入您的电话" v-model="form.empPhone" />
								</div>
								<div class="pull-left">
									<div class="error-info"></div>
								</div>
							</div>

							<div class="form-group">
								<label for="name" class="col-sm-2 control-label"><span class="red-star">*</span> <span
										class="wz">学校</span>：</label>
								<div class="col-sm-7">
									<input id="name" name="name" type="text" class="form-control" placeholder="请输入您的学校"
										v-model="form.empSchool" />
								</div>
								<div class="pull-left">
									<div class="error-info"></div>
								</div>
							</div>
							<div class="form-group">
								<label for="name" class="col-sm-2 control-label"><span class="red-star">*</span> <span
										class="wz">专业</span>：</label>
								<div class="col-sm-7">
									<input id="name" name="name" type="text" class="form-control" placeholder="请输入您的专业"
										v-model="form.empMajor" />
								</div>
								<div class="pull-left">
									<div class="error-info"></div>
								</div>
							</div>
							<div class="form-group">
								<label for="name" class="col-sm-2 control-label"><span class="red-star">*</span> <span
										class="wz">意向岗位</span>：</label>
								<div class="col-sm-7">
									<input id="name" name="name" type="text" class="form-control"
										placeholder="请输入您的意向岗位" v-model="form.postName" />
								</div>
								<div class="pull-left">
									<div class="error-info"></div>
								</div>
							</div>
							<div class="form-group">
								<label for="name" class="col-sm-2 control-label">
									<span class="red-star">*</span> <span class="wz">是否他人推荐：</span>
								</label>
								<div class="col-sm-7">
									<label class="radio-label" style="cursor:pointer;">
										<input type='radio' name='0' value='0' data-rule='required' v-model="form.isSuggest"/>
										自荐&nbsp;&nbsp;
									</label>
									<label class="radio-label" style="cursor:pointer;">
										<input type='radio' name='1' value='1' data-rule='required' v-model="form.isSuggest"/>
										他荐&nbsp;&nbsp;
									</label>
								</div>
								<div class="pull-left">
									<div class="error-info"></div>
								</div>
							</div>
							<div class="form-group">
								<label for="name" class="col-sm-2 control-label"><span class="red-star">*</span> <span
										class="wz">简历</span>：</label>
								<div class="col-sm-7">
									<input id="name" name="name" @change="onFileChange" type="file" class="form-control"
										placeholder="请上传文件" />
								</div>
								<div class="pull-left">
									<div class="error-info"></div>
								</div>
							</div>


							<div class="form-group">
								<div class="col-sm-2 col-xs-12 col-md-offset-2">
									<input type="submit" class="btn btn-primary form-control" name="btn" value="提交" @click="submit"/>
								</div>
							</div>
						</form>

					</div>
				</div>
			</div>


		</div>



		<Footer />





	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';


	import {
		hrVita
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				form: {
					empName: '',
					empAge: '',
					empPhone: '',
					empSchool: '',
					empMajor: '',
					postName: '',
					recommendType: '',
					resumeFile: null,
					vitaUrl: '',
					postId:'',
					isSuggest:''
				},
			}
		},

		mounted() {
			this.form.postId=this.$route.query.id||''
			this.form.postName=this.$route.query.name||''
			this.form.isSuggest=this.$route.query.isSuggest
		},

		methods: {
			onFileChange(e) {
				this.form.resumeFile = e.target.files[0]
				const formData = new FormData();
				formData.append('file', this.form.resumeFile); // 绑定文件对象				  
				axios.post('/sys/file/upload', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(response => {
					let res = response.data
					if (res.code == 200) {
						this.form.vitaUrl = res.data.url
					}

				}).catch(error => {
					console.error('上传失败', error);
				});
			},
			changePhone(val) {
				this.showPhone = val
			},
			submit() {
				console.log(this.form)
				var that=this
				console.log('22222123')
				// 表单交互验证 (利用插件实现的)
				$("#message-form").validator({
					// 验证规则
					fields: {
						name: "required",
						contact: "required;phone",
						email: 'email',
						content: 'required',
						checkcode: 'required;checkcode'
					},
					// 获取当前提示信息抬头
					display: function(el) {
						return $(el).closest('.form-group').find('label span.wz').text();
					},
					// 自定义正则表达式
					rules: {
						phone: [/^1[345789]+\d{9}$/, "请填写有效的手机号"],
						email: [/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, "请填写有效的邮箱"],
						checkcode: [/^[a-zA-Z0-9]{4}$/, "验证码必须为四位数字和字母"]
					},
					// 自定义错误消息提示框
					target: function(elem) {
						var $formitem = $(elem).closest('.form-group'),
							$msgbox = $formitem.find('div.error-info');
						if (!$msgbox.length) {
							$msgbox = $('<span class="msg-box"></span>').appendTo($formitem);
						}
						return $msgbox;
					},
					valid: function(e) {						
						that.submitForm(); // 关键回调函数
					  }
				});

			},
			submitForm(){
				hrVita(this.form).then(res => {
					this.$message.success('简历提交成功')
					this.$router.go(-1)
				});
			},



		}
	}
</script>

<style scoped>


</style>